import React, { useState } from "react";
import LoadingWithLable from "../../../../ReusableComponents/Loading/LoadingWithLable";
import Highlighter from "react-highlight-words";
import useSearchPagination from "../../../../ReusableComponents/SearchPagination/useSearchPagination";
import { setAppError } from "../../../../store/userSlice";
import { useDispatch } from "react-redux";
import { CgSpinner } from "react-icons/cg";
import nodeinstance from "../../../../nodeInstance";
import UploadFilePopUp from "../../../../ReusableComponents/UploadFile/uplaodFile";
import UpdatePopUp from "./UpdatePopUp/UpdatePopUp";

export default function FinListAtmPayRoll({
  token,
  titles = [],
  list = [],
  loading,
  updateData,
}) {


  const {
    NoDataFound,
    Pagination,
    PaginationIndex,
    Search,
    CountPerPage,
    currentList,
  } = useSearchPagination(list?.data || []);

  const [itmeList, setItemList] = React.useState([]);
  const [Popup, setPopUp] = useState(false);
  const [searchWords, setSearchWords] = useState([]);

  const dispatch = useDispatch();

  const [checkedItems, setCheckedItems] = React.useState({});
  const maxSelected = 1505; // Maximum number of items that can be selected


  // Handle individual checkbox change
  const handleCheckboxChange = (event, employee_id, list) => {
    const isChecked = event.target.checked;

    // Update checkedItems state
    setCheckedItems((prevState) => {
      const nextState = { ...prevState };
      if (isChecked) {
        nextState[employee_id] = true; // Mark as checked
      } else {
        delete nextState[employee_id]; // Unmark (remove)
      }
      return nextState;
    });

    // Update itemList state
    setItemList((prevItemList) => {
      const updatedList = prevItemList.filter((item) => item !== list);
      if (isChecked) {
        updatedList.push(list); // Add selected item
      }
      return updatedList;
    });
  };

  // Handle "Select All" checkbox
  const handleSelectAll = (event) => {
    const isChecked = event.target.checked;

    if (isChecked) {
      // Select all checkboxes
      const allCheckedItems = {};
      const allItemList = [];

      currentList.forEach((employee) => {
        allCheckedItems[employee.employee_id] = true;
        allItemList.push(employee); // Assuming each employee has a 'list' field
      });

      setCheckedItems(allCheckedItems);
      setItemList(allItemList);
    } else {
      // Deselect all checkboxes
      setCheckedItems({});
      setItemList([]);
    }
  };

  // Check if all employees are selected
  const isAllSelected = Object.keys(checkedItems).length === currentList.length;

  const update = async (type) => {
    try {
      console.log(type);
      const res = await nodeinstance.post(
        "/employees/updateBorderNumber/",
        type,
        {
          headers: { Authorization: `Bearer ${token}` },
          // body: type
        }
      );
      console.log(res);
      if (res.status == 200) {
        setEditingIndex(-1);
        apiCall();
        dispatch(
          setAppError({
            msg: res?.data?.message,
            color: "success",
          })
        );
      }
    } catch (error) {
      dispatch(
        setAppError({
          msg: error.message,
        })
      );
    }
  };

  const apiCall = () => {
    updateData("123654");
    setCheckedItems({});
  };

  const popOpen = () => {
    var list = Object.entries(checkedItems)
      .filter(([emp_id, isChecked]) => isChecked)
      .map(([emp_id]) => emp_id);
    console.log(checkedItems.length);
    if (list.length === 0) {
      dispatch(
        setAppError({
          msg: "Please select Check box",
        })
      );
    } else {
      setPopUp(true);
    }
  };
  return (
    <>
      <div className="flex-wrap  gap-2 w-full items-center flex flex-row-reverse">
        <button
          className="p-2 px-4 rounded-md bg-blue disabled:bg-gray text-white min-w-fit text-sm flex items-center gap-2"
          onClick={() => popOpen()}
        >
          <p>Update</p>
        </button>

        <Search
          searchKey={["employee_id", "name", "client","visa_provider","iqama_number"]}
          setSearchWords={setSearchWords}
        />
      </div>
      <p className="text-sm w-full text-right font-medium mb-1">{`Slide / scroll to right >`}</p>
      <CountPerPage />
      <div className="relative bg-white">
        <div className="overflow-x-auto max-h-[70vh] ">
          <div className="sticky top-0 z-10 bg-white min-w-[2200px]">
            <div className="grid grid-cols-table-atm-pay-roll gap-5 p-6 text-center">
              {titles.map((t, index) => (
                <p key={index} className="font-semibold uppercase">
                  {t === "ACTION" ? <div>
                    <input
                      type="checkbox"
                      checked={isAllSelected}
                      onChange={handleSelectAll}
                    />
                  </div> : t}
                </p>
              ))}
            </div>
          </div>
          <div className="grid grid-cols-table-atm-pay-roll gap-5 p-6 bg-white text-center">
            {list?.isLoading && <LoadingWithLable className="col-span-full" />}
            {!list?.isLoading && <NoDataFound />}
            {!list?.isLoading &&
              currentList.map((list, index) => (
                <React.Fragment key={index}>
                  <PaginationIndex index={index} />
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.employee_id || "-"}
                    />
                  </p>

                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.name || "-"}
                    />
                  </p>

                  <p className="overflow-x-hidden">
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.client || "-"}
                    />
                  </p>
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.visa_provider || "-"}
                    />
                  </p>

                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.iqama_number || "-"}
                    />
                  </p>

                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.iqama_expiry_date_g || "-"}
                    />
                  </p>

                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.iqama_expiry_date_h || "-"}
                    />
                  </p>
                  {/* ACCOUNT TO BE OPENED BY */}
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.mobile_number || "-"}
                    />
                  </p>
                  {/* FEES */}
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.payroll_category || "-"}
                    />
                  </p>
                  {/* PAYMENT STATUS */}
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.fees || "-"}
                    />
                  </p>

                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.payment_status || "-"}
                    />
                  </p>
                  <div>
                    <input
                      disabled={
                        checkedItems[list.employee_id] &&
                        Object.values(checkedItems).filter(Boolean).length >=
                        maxSelected
                      }

                      type="checkbox"
                      checked={!!checkedItems[list.employee_id]}
                      onChange={(e) => handleCheckboxChange(e, list.employee_id, list)}
                    />
                  </div>

                  <hr
                    className={`border-[1.5px] border-slate-100  w-full col-span-full `}
                  />
                </React.Fragment>
              ))}
          </div>
        </div>
      </div>
      {Popup ? (
        <UpdatePopUp
          list={itmeList}
          PopUp={Popup}
          setPopUp={setPopUp}
          title={"Update fee and payment status"}
          url={"/atm-payroll/updateFees"}
          callBack={apiCall}
        />
      ) : (
        ""
      )}
    </>
  );
}
